import { LiveScore } from "./LiveScore";
import { Model } from "./Model";

export interface LiveScorePage extends Model {
pageNumber: number;
leagueName: string;
liveScores: LiveScore[];
}

export class LiveScorePage implements LiveScorePage {

	constructor(data?: Partial<LiveScorePage>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}